import { render } from "./fixedbar.vue?vue&type=template&id=511d57eb"
import script from "./fixedbar.vue?vue&type=script&lang=js"
export * from "./fixedbar.vue?vue&type=script&lang=js"

import "./fixedbar.vue?vue&type=style&index=0&id=511d57eb&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@5.111.1_postcss@8.5.29_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__